import request from "../plugins/axios";

export function mediumGroup(params) {
    return request({
        url: '/mediumGroup/index',
        method: 'GET',
        params
    })
}
export function groupStore(data) {
    return request({
        url: '/mediumGroup/store',
        method: 'POST',
        data
    })
}
export function medium(data) {
    return request({
        url: '/medium/store',
        method: 'POST',
        data
    })
}
export function mediumUpdate(data) {
    return request({
        url: '/medium/update',
        method: 'PUT',
        data
    })
}
export function mediumShow(params) {
    return request({
        url: '/medium/show',
        method: 'GET',
        params
    })
}
export function mediumList(params) {
    return request({
        url: '/medium/index',
        method: 'GET',
        params
    })
}
export function destroy(data) {
    return request({
        url: '/medium/destroy',
        method: 'DELETE',
        data
    })
}
